/* 閲覧中は紹介モードを保つ（docs/ip-referral-attribution.md）。ブランド（コレクションのブランドページ）も紹介者と同じ扱い。
   紹介用のページ（紹介者ページ・その商品・そのカート）とブランドのページ（コレクション・その商品）で覚え、お店のトップ・カート・
   一覧・ポリシーなどへ来たら、ヘッダーをそのタイトルにして「販売ページに戻る／〇〇」のボタンを出す。覚えるのは最後に見た1件の ID・タイトル・URL だけで、期限は無い。 */
(function () {
  'use strict';
  var key = 'ip:referral:v1';
  // 紹介者ページ（/pages/…）かブランドのコレクション（/collections/…）。外部・別のパスへは戻さない。
  var pagePath = /^(\/[a-z]{2}(-[a-z]{2})?)?\/(pages\/[a-z0-9-]+|collections\/[^\/?#\s"'<>]+)$/;

  var remember = document.querySelector('[data-ip-referral-remember]');
  if (remember) {
    var d = remember.dataset;
    try {
      // Ended, or no referrer page to go back to: forget, so an earlier referrer is not shown instead.
      if (d.ended === 'true' || !pagePath.test(d.url || '')) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, JSON.stringify({ code: d.code, title: d.title, url: d.url, ended: false, at: Date.now() }));
    } catch (e) { /* Storage may be unavailable; referral pages work without it. */ }
    return;
  }

  var marker = document.querySelector('[data-ip-referral-recall]');
  if (!marker) return;
  var active = (marker.dataset.active || '').split(',');
  var saved = null;
  try { saved = JSON.parse(window.localStorage.getItem(key)); } catch (e) { saved = null; }
  var root = document.documentElement;
  if (!saved || saved.ended || active.indexOf(saved.code) < 0 || !pagePath.test(saved.url || '') || !saved.title) {
    try { if (saved && active.indexOf(saved.code) < 0) window.localStorage.removeItem(key); } catch (e) { /* optional storage */ }
    root.classList.remove('ip-referral-recall');
    return;
  }

  var brand = document.querySelector('.ip-header .site-brand');
  if (brand) {
    // ブランドのページと同じ「名前 × ストア名」。カート・お会計はストア名で進むので、ストア名を落とさない。
    brand.textContent = saved.title + ' ';
    if (brand.dataset.shop) {
      var by = document.createElement('span');
      by.className = 'ip-referral-title__by';
      by.textContent = '× ' + brand.dataset.shop;
      brand.appendChild(by);
    }
    brand.setAttribute('href', saved.url);
    brand.classList.add('ip-referral-title');
  }
  var copy = document.querySelector('[data-ip-footer-copy]');
  if (copy) copy.textContent = saved.title + ' × ' + (copy.dataset.shop || '');
  var main = document.getElementById('MainContent');
  // ログイン中のトップに、購入したブランドのボタンとして同じ行き先がすでにあれば、先頭に移すだけにする。
  var purchased = Array.prototype.filter.call(document.querySelectorAll('[data-ip-purchased-brand]'), function (el) {
    return el.querySelector('a') && el.querySelector('a').getAttribute('href') === saved.url;
  })[0];
  if (purchased) purchased.parentNode.insertBefore(purchased, purchased.parentNode.firstChild);
  if (main && !purchased && !document.querySelector('.ip-referral-recall-banner:not([data-ip-purchased-brand])')) {
    var box = document.createElement('div');
    box.className = 'ip-referral-recall-banner page-width';
    var link = document.createElement('a');
    link.className = 'btn';
    link.href = saved.url;
    var label = document.createElement('span');
    label.className = 'ip-referral-recall-banner__label';
    label.textContent = '販売ページに戻る';
    var name = document.createElement('span');
    name.className = 'ip-referral-recall-banner__name';
    name.textContent = saved.title;
    link.appendChild(label);
    link.appendChild(name);
    box.appendChild(link);
    // お店のトップでは、紹介文の下のボタンの並び（「前に見ていた商品一覧に戻る」の場所）に置く。そのボタンは CSS で隠す。
    var homeActions = main.querySelector('.ip-home__actions');
    if (homeActions) {
      box.className = 'ip-referral-recall-banner ip-referral-recall-banner--home';
      homeActions.insertBefore(box, homeActions.firstChild);
    } else {
      main.insertBefore(box, main.firstChild);
    }
  }
  root.classList.remove('ip-referral-recall');
  root.classList.add('ip-referral-recalled');
})();
